import './App.css';
import './Component/Syncfusion.css';
import { Route, Switch, Redirect } from 'react-router-dom';
import Home from './Pages/Home';
import AboutUs from './Pages/AboutUs';
import Vettriage from './Pages/Vettriage';
import Error from './Pages/Error';
import Services from './Pages/Services';
import Contact from './Pages/Contact';
import Header from './Component/Header';
import Footer from './Component/Footer';
import MemberLogin from './Component/MemberLogin';
import ForgotPassword from './Component/ForgotPassword';
import MemberRegistration from './Component/MemberRegistration';
import UpdateProfileNew from './Component/UpdateProfileNew';
import Member from './Component/Member';
import Admin from './Component/Admin/Admin';
import VideoCall from './Component/VideoCall';

const App = () => {
  return (
    <div>
      <Header />
      <Switch>                
        <Route exact path='/' component={Home} />
        <Route exact path='/about-us' component={AboutUs} />
        <Route exact path='/services' component={Services} />
        <Route exact path='/contact' component={Contact} />
        <Route exact path='/vettriage' component={Vettriage} />
        <Route exact path='/member-login' component={MemberLogin} />
        <Route exact path='/forgot-password' component={ForgotPassword} />
        <Route exact path='/member-registration' component={MemberRegistration} />
        <Route exact path='/update-profile-new' component={UpdateProfileNew} />
        <Route path='/member' component={Member} />
        <Route path='/admin' component={Admin} />
        <Route exact path='/video-call' component={VideoCall} />        
        <Route component={Error} />
        {/* <Redirect from="/" exact to="/dashboard" /> */}        
      </Switch>
      <Footer />
    </div>
  )
}

export default App;